import {createContext, useReducer} from 'react'

// creating context
export const InvoiceContext = createContext()

// reducer function
export const invoiceReducer = (state, action) => {

    // switching through action
    switch(action.type){
        // this will set the current clients as the current state
        case "SET_INVOICES":
            return {
                invoices: action.payload
            }
        // This will set the current client state as the current client state + the new client we pass in     
        case "CREATE_INVOICE":
            if(state.invoices == null){
                return [action.payload]
            }
            else{
                return{
                    invoices: [action.payload, ...state.invoices]
                }
            }
            
        // This will filter through the current state of clients, and return all of them except the one we pass in (the one we are deleting)     
        case "DELETE_INVOICE":
            return{
                invoices: state.invoices.filter((invoice) => invoice._id !== action.payload._id)
            }
        // otherwise we just return the state     
        default:
            return state            
    }
}

// this provides the context
export const InvoicesContextProvider = ({children}) => {

    // this is our state + reducer function, which we will pass down as a value to our children below 
    const [state, dispatch] = useReducer(invoiceReducer, {
        invoices: null
    })

    const calculateTotal = () => {
        if (state.invoices) {
          return state.invoices.reduce((total, invoice) => {
            // Remove non-numeric characters and convert to a float
            const numericValue = parseFloat(invoice.invoiceTotal.replace(/[^0-9.]/g, '')) || 0;
            return total + numericValue;
          }, 0);
        }
        return 0;
      };

    return (

        <InvoiceContext.Provider value={{...state,dispatch, calculateTotal}}>
            {children}
        </InvoiceContext.Provider>
    )
}

